import * as React from "react";
import { forwardRef } from "react";
const SvgHamburgerMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 44 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4.8125, y: 20.625, width: 34.375, height: 2.0625, rx: 1.03125, fill: "#35302F" }), /* @__PURE__ */ React.createElement("rect", { x: 4.8125, y: 29.5625, width: 34.375, height: 2.0625, rx: 1.03125, fill: "#35302F" }), /* @__PURE__ */ React.createElement("rect", { x: 4.8125, y: 11.6875, width: 34.375, height: 2.0625, rx: 1.03125, fill: "#35302F" }));
const ForwardRef = forwardRef(SvgHamburgerMenu);
export { ForwardRef as ReactComponent };
